import {useExpert} from '~/modules/Common/hooks/useExpert';

export function useExpertTheme() {
  const {theme} = useExpert();
  return theme;
}
